import axios from 'axios';
let prod = 'https://system.payeasy.tech:2083';
let hml = 'https://mercadoeasy-back-hml-dashboard.herokuapp.com';
let local='http://localhost:3333';

//Endpoint para a API do back-end que fica na VPS da fastcoin
export const ApiMail = axios.create({
    baseURL: prod,
    headers: { 'Content-Type': 'application/json' },
    timeout: 35000
})

//Endpoint para a máquina local, utilizado em casos de teste
export const LocalAPI = axios.create({
    baseURL: 'https://system.payeasy.tech:2083',
    headers: { 'Content-Type': 'application/json' },
    timeout: 15000,
})
